import { Clock, BadgeEuro, ShieldCheck, Users, Wrench, Phone } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";

export const WhyUs = () => {
  const { t, lang } = useLang();

  const items = [
    { icon: Clock, de: { t: "15 Min Anfahrt", d: "Mobile Teams in allen 23 Bezirken – wir sind in der Regel in 15–20 Minuten bei Ihnen." }, en: { t: "15 min arrival", d: "Mobile teams in all 23 districts – usually on site in 15–20 minutes." } },
    { icon: BadgeEuro, de: { t: "Festpreis-Garantie", d: "Sie erhalten den Preis vorab am Telefon. Keine versteckten Kosten." }, en: { t: "Fixed-price guarantee", d: "Get the price upfront by phone. No hidden costs." } },
    { icon: ShieldCheck, de: { t: "Geprüft & versichert", d: "Alle Techniker sind zertifiziert, haftpflichtversichert und behördlich gemeldet." }, en: { t: "Certified & insured", d: "All technicians are certified, insured and officially registered." } },
    { icon: Wrench, de: { t: "Schadenfreie Öffnung", d: "In 95 % der Fälle öffnen wir Ihre Tür ohne Beschädigung des Schlosses." }, en: { t: "Damage-free opening", d: "In 95% of cases we open your door without damaging the lock." } },
    { icon: Phone, de: { t: "24/7 erreichbar", d: "Tag und Nacht, Sonn- und Feiertage – wir sind immer für Sie da." }, en: { t: "24/7 available", d: "Day and night, Sundays and holidays – we're always here." } },
    { icon: Users, de: { t: "1.200+ zufriedene Kunden", d: "Über 1.200 Bewertungen mit 4,9 Sternen sprechen für sich." }, en: { t: "1,200+ happy customers", d: "Over 1,200 reviews with 4.9 stars speak for themselves." } },
  ];

  return (
    <section className="py-20 md:py-24 bg-secondary/40">
      <div className="container">
        <div className="max-w-2xl mb-12">
          <span className="text-accent font-semibold uppercase tracking-widest text-sm">{t("section.why.kicker")}</span>
          <h2 className="font-display text-4xl md:text-6xl text-primary mt-3 mb-4">{t("section.why.title")}</h2>
          <p className="text-muted-foreground text-lg">{t("section.why.subtitle")}</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {items.map((it, i) => {
            const c = lang === "de" ? it.de : it.en;
            return (
              <div key={i} className="bg-card border border-border rounded-2xl p-6 shadow-card-soft">
                <div className="inline-flex w-12 h-12 rounded-xl bg-accent/15 text-accent items-center justify-center mb-4">
                  <it.icon className="w-6 h-6" />
                </div>
                <h3 className="font-display text-xl text-primary mb-2 tracking-wide">{c.t}</h3>
                <p className="text-muted-foreground text-sm leading-relaxed">{c.d}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};